import {
  useCallback,
  useLayoutEffect,
  useRef,
  useSyncExternalStore,
} from "react";

import type { SiteLink } from "@softmax/web-features/site/records";
import {
  acquireNavigationInteraction,
  beginNavigationActivity,
} from "@softmax/web-features/navigation/activity";

import { AccountPill } from "./account-pill";
import type { PillViewer } from "./pill-viewer";

const subscribeHydration = () => () => {};

export function SiteAccountPill({
  viewer,
  leagues,
}: {
  viewer: PillViewer | null;
  leagues: SiteLink[];
}) {
  const hydrated = useSyncExternalStore(
    subscribeHydration,
    () => true,
    () => false,
  );
  const releaseInteraction = useRef<(() => void) | null>(null);
  const onOpenChange = useCallback((next: boolean) => {
    if (next) releaseInteraction.current ??= acquireNavigationInteraction();
    else {
      releaseInteraction.current?.();
      releaseInteraction.current = null;
    }
  }, []);

  useLayoutEffect(
    () => () => {
      releaseInteraction.current?.();
      releaseInteraction.current = null;
    },
    [],
  );

  return (
    <AccountPill
      viewer={viewer}
      hydrated={hydrated}
      leagues={leagues}
      onOpenChange={onOpenChange}
      onNavigationAccepted={(href) => beginNavigationActivity({ href })}
    />
  );
}
